import { render, staticRenderFns } from "./CommunityPopular.vue?vue&type=template&id=2d09c602&"
import script from "./CommunityPopular.vue?vue&type=script&lang=js&"
export * from "./CommunityPopular.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPopular.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QToolbarTitle,QInfiniteScroll,QList,QItem,QInnerLoading,QSpinner,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtn,QToolbarTitle,QInfiniteScroll,QList,QItem,QInnerLoading,QSpinner,QItemSection,QItemLabel})
